module.exports = __webpack_public_path__ + "static/media/Spot_Privacy_Policy_CA.8d11081f.pdf";